/**
 * @desc 修改供应商sku报价发起工作流
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierQuotationUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/updateApproveSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
